module.exports = __webpack_public_path__ + "static/img/yitai.43b15b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/yitai.jpg
// module id = y3Ew
// module chunks = 1